const WrapPage = require("sites-common/gatsby-utils/WrapPage").default;

exports.wrapPageElement = WrapPage;
